import { ApiService } from '../apiService'

/**
 * Anonymised location-activity heatmap (Marketing → Location Activity).
 * Mirrors the Admin API DTOs in AdventureCore.Application/DTOs/Admin/LocationHeatmapDto.cs.
 * Counts are per-window activity/visits, not distinct people.
 */
export interface HeatmapPoint {
  lat: number
  lng: number
  /** Cell bounding box (geohash bbox) so grid rectangles tile the grid exactly. */
  south: number
  west: number
  north: number
  east: number
  /** Tier-selected count driving heat intensity (total when tier = all). */
  weight: number
  free: number
  basic: number
  premium: number
}

export interface HeatmapFrame {
  /** 30-minute window start (UTC ISO), or null for the aggregate frame. */
  windowStart: string | null
  points: HeatmapPoint[]
}

export interface LocationHeatmapResponse {
  from: string
  to: string
  tier: string
  level: number
  minCount: number
  /** Approx. cell edge length in km for the chosen level (legend hint). */
  cellKm: number
  /** Highest single-cell weight across all frames (for intensity scaling). */
  maxWeight: number
  frames: HeatmapFrame[]
}

export type HeatmapTier = 'all' | 'free' | 'basic' | 'premium'

export interface LocationHeatmapParams {
  /** UTC ISO string, inclusive. */
  from: string
  /** UTC ISO string, exclusive. */
  to: string
  tier?: HeatmapTier
  /** 5 (~4.8km) or 6 (~1.2km). */
  level?: number
  minCount?: number
  /** Single summed frame instead of per-window playback frames. */
  aggregate?: boolean
}

export const marketingApi = {
  getLocationHeatmap: (params: LocationHeatmapParams) =>
    ApiService.get<LocationHeatmapResponse>('/admin/marketing/location-heatmap', params),
}
